import { render, staticRenderFns } from "./SpecialOffersItem.vue?vue&type=template&id=6fed24a0&scoped=true&"
import script from "./SpecialOffersItem.vue?vue&type=script&lang=js&"
export * from "./SpecialOffersItem.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOffersItem.vue?vue&type=style&index=0&id=6fed24a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed24a0",
  null
  
)

export default component.exports